import React from 'react';

import PageSkeleton from '../../components/skeleton/PageSkeleton';
import createRouteLoadable from './createRouteLoadable';

export const VEHICLE_PART_SEARCH_PAGE_CHUNK_NAME = 'vehiclePartSearchPage';

export const VehiclePartSearchPage = createRouteLoadable(
  () =>
    import(
      /* webpackChunkName: "vehiclePartSearchPage" */ '../../pages/VehiclePartSearchPage'
    ),
  {
    fallback: <PageSkeleton />,
  }
);
